const PRIMARY_COLOR = "#3BAEC7";
const OK_GREEN = "#43a047";
const WARN_YELLOW = "#efa94a";
const ERROR_RED = "#7f0000";


let Colors = {
    primary: PRIMARY_COLOR,
    commonBackground: "#e0e0e0",
    fieldHelpIcon : "#B0BEC5",

    // Tables
    tableTitle1Bg: PRIMARY_COLOR,
    tableTitle1Text: "#fff",
    tableNormalBg: "#fff",
    tableNormalText: "#000",
    tableNormalHLRedBg: "#f05545",
    tableNormalHLRedText: "#fff",
    tableNormalHLYellowBg: "#ffff72",
    tableNormalHLYellowText: "#000",
    tableNormalHLOrangeBg: "#ff833a",
    tableNormalHLOrangeText: "#000",
};

Colors.iconOk= OK_GREEN;
Colors.iconWarn= WARN_YELLOW;
Colors.iconError= ERROR_RED;

Colors.warning= WARN_YELLOW;
Colors.error= ERROR_RED;


export {
    Colors as default
};
